/* COMPONENT IMPORTS*/
import { ErrorPage } from "../../components/ErrorPage/ErrorPage";
import { ReactPlugin, withAITracking } from "@microsoft/applicationinsights-react-js";
import ContextConstructor from "../../components/Context/Context";
import MGModalityHeader from "../../components/MGModalityHeader/MGModalityHeader";
import MGMyModalities from "../../components/MGMyModalities/MGMyModalities";
import MGModalitySubscription from "../../components/MGModalityCardsSubscription/MGModalitySubscription";
import sendLogError from "../../sendLogError";
import MGMySubscriptions from "../../components/MGMySubscriptions/MGMySubscriptions";
import { MGMySubscriptionDetailCardType } from "../../components/MGMySubscriptions/MGMySubscriptionDetailCardType";
import { getPublicURL } from "../../env";

/* MODULE IMPORTS */
import React, { Component, useState } from "react";
import { MGModalityStep } from "../../utils/MGModalityStep";

/* CSS IMPORT */
import "../../components/Loading/loading.css";
import "./Poupanca.css";
import loadingImg from "../../images/loading.svg";
import { ArrowLeft } from 'lucide-react';
import poupancas from "../../images/Modality/poupancas.svg"

var reactPlugin = new ReactPlugin();

class Poupanca extends Component {
  static displayName = Poupanca.name;

  constructor(props) {
    super(props);
    this.state = {
      savings: [],
      error: [],
      loading: true,
      canCreateNew: false,
      step: MGModalityStep.DASHBOARD,
      item: ""
    };
  }

  componentDidMount() {
    if (
      this.context.selectedUserID !== "" &&
      this.context.selectedUserID !== undefined &&
      this.context.selectedUserID !== null
    ) {
      this.populatePortfolioData();
    }
  }

  transformActives(a) {
    if (a == "1") return a + " subscrição ativa";
    else return a + " subscrições ativas";
  }

  errorLoadingPortfolio() {
    return (
      <div>
        <ErrorPage />
      </div>
    );
  }

  handleBack() {
    if (window.history.length > 1) {
      window.history.back();
    } else {
      window.history.replaceState(null, "", "/");
    }
  }

  changeValueColor(value) {
    if (value != "0.0") {
      return (
        <React.Fragment>
          <div className="table-applied">
            {new Intl.NumberFormat("de-DE", { style: "currency", currency: "EUR" }).format(value)}
          </div>
        </React.Fragment>
      );
    } else {
      return (
        <React.Fragment>
          <td className="table-applied" style={{ color: "#B2B2B2" }}>
            {new Intl.NumberFormat("de-DE", { style: "currency", currency: "EUR" }).format(value)}
          </td>
        </React.Fragment>
      );
    }
  }

  renderPortfolioData(state) {
    return (
      <>
        <header className="Savings-header" />
        <main className="Savings-main">
          <MGModalityHeader
            subscriptionActivity={this.transformActives(state.savings.subscriptionsNumber)}
            icon={poupancas}
            title={'Poupança'}
            leftTitle={"Montante aplicado"}
            leftAmount={new Intl.NumberFormat("de-DE", { style: "currency", currency: "EUR" }).format(state.savings.totalAmounts.totalInvestedAmount)}
            rightTitle={"Rendimento bruto"}
            rightAmount={new Intl.NumberFormat("de-DE", { style: "currency", currency: "EUR" }).format(state.savings.totalAmounts.totalReceivedAmount)}
            rightColor="#55772A" />
          <MGMyModalities
            myModalities={state.savings}
            leftTitle={"Montante aplicado"}
            rightTitle={"Rendimento bruto"}
            rightColor="#55772A"
            onClick={(key) => {
              this.setState({ step: MGModalityStep.DETAIL, item: key })
            }}
          />
          <MGModalitySubscription id={"1"} context={this.context} myModalities={state.savings.productTypes} publicURL={getPublicURL()} />
        </main>
      </>
    );
  }

  renderSavingDetail(state) {
    const { productName, subscriptionsNumber, totalAmounts, subscriptions } = this.filterSavingList(state);

    return (
      <div>
        <header className="Savings-header">
          <ArrowLeft onClick={() => { this.setState({ step: MGModalityStep.DASHBOARD, item: "" }) }} />
          Voltar a Poupança
        </header>
        <main className="Savings-main">
          <MGModalityHeader
            subscriptionActivity={this.transformActives(subscriptionsNumber)}
            icon={poupancas}
            title={productName}
            leftTitle={"Montante aplicado"}
            leftAmount={new Intl.NumberFormat("de-DE", { style: "currency", currency: "EUR" }).format(totalAmounts.totalInvestedAmount)}
            rightTitle={"Rendimento bruto"}
            rightAmount={new Intl.NumberFormat("de-DE", { style: "currency", currency: "EUR" }).format(totalAmounts.totalReceivedAmount)}
            rightColor="#55772A" />
          <MGMySubscriptions mySubscriptions={subscriptions} subscriptionDetailCardType={MGMySubscriptionDetailCardType.SAVING} />
        </main>
      </div>
    );
  }

  filterSavingList(state) {
    return state.savings.productTypes.find((i) => (i.productID === state.item))
  }

  renderPage(state) {
    switch (state.step) {
      case MGModalityStep.DASHBOARD:
        return this.renderPortfolioData(state);
      case MGModalityStep.DETAIL:
        return this.renderSavingDetail(state);
      default:
        return this.renderPortfolioData(state);
    }
  }

  render() {
    let contents = this.state.loading ? (
      <div className="main-page-loading">
        <div className="loading">
          <img src={loadingImg}></img>
        </div>
      </div>
    ) : this.state.error ? (
      this.errorLoadingPortfolio()
    ) : (
      <div className="main">
        {this.renderPage(this.state)}
      </div>

    );
    return <>{contents}</>;
  }

  async populatePortfolioData() {
    try {
      let canCreateNew = false;
      let nSavingsWithSubscriptions = 0;

      const { idToken, selectedUserID } = this.context;

      const headers = {
        Authorization: `Bearer ${idToken}`,
        clientId: selectedUserID,
      };

      const response = await fetch("/Portfolio/GetPortfolio", { headers });

      if (!response.ok) {
        this.setState({
          savings: {},
          error: false,
          loading: false,
          canCreateNew,
          nSavingsWithSubscriptions,
        });

        return;
      }

      const data = await response.json();

      const productTypes = Array.isArray(data?.savings?.productTypes)
        ? data.savings.productTypes
        : [];

      productTypes.forEach((product) => {
        if (product.productID === "7335") {
          return; // ignora este produto
        }

        if (Number(product.subscriptionsNumber || 0) === 0) {
          canCreateNew = true;
        } else {
          nSavingsWithSubscriptions += 1;
        }
      });

      this.setState({
        savings: data?.savings || {},
        error: false,
        loading: false,
        canCreateNew,
        nSavingsWithSubscriptions,
      });

    } catch (error) {
      console.error("Error fetching portfolio:", error);

      this.setState({
        error: true,
        loading: false,
      });

      sendLogError(error.message, "populatePortfolioData");
    }
  }
}

Poupanca.contextType = ContextConstructor;

export default withAITracking(reactPlugin, Poupanca);
